import {
  Component,
  computed,
  input,
  output
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

enum ButtonVariant {
  FILLED = 'filled',
  ACCENT = 'accent',
  OUTLINED = 'outlined'
}

@Component({
  selector: 'isc-button',
  imports: [
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './button.html',
  styleUrl: './button.scss'
})
export class Button {

  // ======================================================
  // INPUTS
  // ======================================================

  readonly type =
    input<ButtonVariant | string>(
      ButtonVariant.FILLED
    );

  readonly label =
    input('');

  readonly icon =
    input<string>('');

  readonly iconPosition =
    input<'start' | 'end'>('start');

  readonly styleClass =
    input('');

  readonly disabled =
    input(false);

  // ======================================================
  // OUTPUTS
  // ======================================================

  readonly onClick =
    output<void>();

  // ======================================================
  // ENUM ACCESS
  // ======================================================

  protected readonly button =
    ButtonVariant;

  // ======================================================
  // STATE
  // ======================================================

  protected readonly isDisabled =
    computed(() => this.disabled());

  // ======================================================
  // EVENTS
  // ======================================================

  handleClick(): void {

    if (this.isDisabled()) {
      return;
    }

    this.onClick.emit();
  }
}